import { render, staticRenderFns } from "./HelpButton.vue?vue&type=template&id=faf8fe80&scoped=true"
import script from "./HelpButton.vue?vue&type=script&lang=ts"
export * from "./HelpButton.vue?vue&type=script&lang=ts"
import style0 from "./HelpButton.vue?vue&type=style&index=0&id=faf8fe80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf8fe80",
  null
  
)

export default component.exports